import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import MenuItem from '@mui/material/MenuItem';
import {
    medthodsOfDispatch,
    transports,
    typesOfShipment
} from '../../../../../../utils/appconstants';
import PortsAutocomplete from '../../../../../autocompletewithapi/PortsAutocomplete';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import CustomTextField from '../../../../../CustomTextInput';
import NewCustomSelect from '../../../../../newcustomselect/newcustomselect';
import { SuitUIButton } from '../../../../../SuitUIButton';
import UploadLogo from '../../../common/UploadLogo';
import UploadStamp from '../../../common/UploadStamp';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    CertificateOfOrigin,
    CertificateOfOriginFormErrors
} from '../../../../../../interfaces/CertificateOfOrigin';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import Certificateoforiginfield from '../../../../../../pages/dashboard/tradedocuments/housebilloflading/certificateoforigin/certificateoforigin/certificateoforiginfield';

interface CertificateOfOriginStepOneFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: CertificateOfOrigin;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: CertificateOfOriginFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    addQuoteField: () => void;
}

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField
}: CertificateOfOriginStepOneFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <UploadLogo {...{ payload, updateField }} />

            <UploadStamp {...{ payload, updateField }} />

            <NewCustomSelect
                hasError={errors?.exporterId.length > 0}
                helperText={
                    errors?.exporterId.length > 0
                        ? errors?.exporterId
                        : undefined
                }
                selectValue={payload.exporterId}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'exporterId'}
                updateField={(_, value) => {
                    updateField('exporterId', value);
                    updateField(
                        'exporterAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                    updateField(
                        'exporterName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                    updateField(
                        'exporterBankName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'exporterAccountNumber',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'exporterSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.swiftCode
                    );
                }}
                label={'Exporter'}
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.exporterAddress.length > 0}
                helperText={
                    errors?.exporterAddress.length > 0
                        ? errors?.exporterAddress
                        : undefined
                }
                value={payload?.exporterAddress}
                required
                id='quotation-exporterAddress'
                label='Exporter Address'
                name='exporterAddress'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('exporterAddress', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.exportInvoiceNumber.length > 0}
                helperText={
                    errors?.exportInvoiceNumber.length > 0
                        ? errors?.exportInvoiceNumber
                        : undefined
                }
                required
                id='proformainvoice-exportInvoiceNumber'
                label='Invoice Number'
                name='exportInvoiceNumber'
                value={payload?.exportInvoiceNumber}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('exportInvoiceNumber', e.target.value);
                }}
            />

            <Customdatepicker
                value={
                    payload?.exportInvoiceDate !== undefined
                        ? payload?.exportInvoiceDate
                        : null
                }
                id='quotation-issuedDate'
                label='Exporter Invoice Date'
                name='exportInvoiceDate'
                updateField={updateField}
                error={errors?.exportInvoiceDate.length > 0}
                helperText={
                    errors?.exportInvoiceDate.length > 0
                        ? errors?.exportInvoiceDate
                        : undefined
                }
            />

            <CustomTextField
                error={errors?.letterOfCreditNumber.length > 0}
                helperText={
                    errors?.letterOfCreditNumber.length > 0
                        ? errors?.letterOfCreditNumber
                        : undefined
                }
                required
                id='proformainvoice-letterOfCreditNumber'
                label='Letter of Credit Number'
                name='letterOfCreditNumber'
                value={payload?.letterOfCreditNumber}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('letterOfCreditNumber', e.target.value);
                }}
            />

            <NewCustomSelect
                hasError={errors?.consigneeId.length > 0}
                helperText={
                    errors?.consigneeId.length > 0
                        ? errors?.consigneeId
                        : undefined
                }
                selectValue={payload.consigneeId}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'consigneeId'}
                updateField={(_, value) => {
                    updateField('consigneeId', value);
                    updateField(
                        'consigneeAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                    updateField(
                        'consigneeName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                    updateField(
                        'consigneeBankName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'consigneeAccountNumber',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'consigneeSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.swiftCode
                    );
                }}
                label={'Consignee'}
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.consigneeAddress.length > 0}
                helperText={
                    errors?.consigneeAddress.length > 0
                        ? errors?.consigneeAddress
                        : undefined
                }
                value={payload?.consigneeAddress}
                required
                id='quotation-consigneeAddress'
                label='Consignee Address'
                name='consigneeAddress'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('consigneeAddress', e.target.value);
                }}
            />

            <NewCustomSelect
                hasError={errors?.buyerId.length > 0}
                helperText={
                    errors?.buyerId.length > 0 ? errors?.buyerId : undefined
                }
                selectValue={payload.buyerId}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'buyerId'}
                updateField={(_, value) => {
                    updateField('buyerId', value);
                    updateField(
                        'buyerName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                    updateField(
                        'buyerAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                }}
                label={'Buyer'}
                // alternativeValue='shippingLineId'
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.buyerAddress.length > 0}
                helperText={
                    errors?.buyerAddress.length > 0
                        ? errors?.buyerAddress
                        : undefined
                }
                value={payload?.buyerAddress}
                required
                id='quotation-buyerAddress'
                label='Buyer Address'
                name='buyerAddress'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('buyerAddress', e.target.value);
                }}
            />

            <CustomTextField
                select
                error={errors?.methodOfDispatch.length > 0}
                helperText={
                    errors?.methodOfDispatch.length > 0
                        ? errors?.methodOfDispatch
                        : undefined
                }
                required
                id='certificateoforgin-methodOfDispatch'
                label='Method of Dispatch'
                name='methodOfDispatch'
                value={payload?.methodOfDispatch}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('methodOfDispatch', e.target.value);
                }}
            >
                {medthodsOfDispatch.map((item, index) => (
                    <MenuItem
                        value={item}
                        key={`medthodsOfDispatch-${item}-${index}`}
                    >
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <CustomTextField
                select
                error={errors?.typeOfShipment.length > 0}
                helperText={
                    errors?.typeOfShipment.length > 0
                        ? errors?.typeOfShipment
                        : undefined
                }
                required
                id='certificateoforgin-typeOfShipment'
                label='Type of Shipment'
                name='typeOfShipment'
                value={payload?.typeOfShipment}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('typeOfShipment', e.target.value);
                }}
            >
                {typesOfShipment.map((item, index) => (
                    <MenuItem
                        value={item}
                        key={`typesOfShipment-${item}-${index}`}
                    >
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <CustomTextField
                select
                error={errors?.transport.length > 0}
                helperText={
                    errors?.transport.length > 0 ? errors?.transport : undefined
                }
                required
                id='certificateoforgin-transport'
                label='Transport'
                name='transport'
                value={payload?.transport}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('transport', e.target.value);
                }}
            >
                {transports.map((item, index) => (
                    <MenuItem value={item} key={`transports-${item}-${index}`}>
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <CustomTextField
                error={errors?.voyageNumber.length > 0}
                helperText={
                    errors?.voyageNumber.length > 0
                        ? errors?.voyageNumber
                        : undefined
                }
                required
                id='proformainvoice-voyageNumber'
                label='Voyage Number'
                name='voyageNumber'
                value={payload?.voyageNumber}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('voyageNumber', e.target.value);
                }}
            />

            <PortsAutocomplete
                errorCondition={errors?.portOfLoadingId.length > 0}
                helperText={
                    errors?.portOfLoadingId.length > 0
                        ? errors?.portOfLoadingId
                        : undefined
                }
                id='quotation-portOfLoading'
                label='Port of Loading'
                name='portOfLoadingId'
                updateField={updateField}
                nameValue='portOfLoadingValue'
                value={payload.portOfLoadingValue}
            />

            <PortsAutocomplete
                errorCondition={errors?.portOfDischargeId.length > 0}
                helperText={
                    errors?.portOfDischargeId.length > 0
                        ? errors?.portOfDischargeId
                        : undefined
                }
                id='quotation-portOfDischarge'
                label='Port of Discharge'
                name='portOfDischargeId'
                updateField={updateField}
                nameValue='portOfDischargeValue'
                value={payload.portOfDischargeValue}
            />

            <Customdatepicker
                value={
                    payload?.dateOfDeparture !== undefined
                        ? payload?.dateOfDeparture
                        : null
                }
                id='quotation-dateOfDeparture'
                label='Date of Departure'
                name='dateOfDeparture'
                updateField={updateField}
                error={errors?.dateOfDeparture.length > 0}
                helperText={
                    errors?.dateOfDeparture.length > 0
                        ? errors?.dateOfDeparture
                        : undefined
                }
            />

            <CustomTextField
                error={errors?.finalDestination.length > 0}
                helperText={
                    errors?.finalDestination.length > 0
                        ? errors?.finalDestination
                        : undefined
                }
                required
                id='certificateoforgin-finalDestination'
                label='Final Destination'
                name='finalDestination'
                value={payload?.finalDestination}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('finalDestination', e.target.value);
                }}
            />

            <CustomTextField
                multiline
                rows={4}
                error={errors?.packingDetails.length > 0}
                helperText={
                    errors?.packingDetails.length > 0
                        ? errors?.packingDetails
                        : undefined
                }
                // required

                id='certificateoforgin-packingDetails'
                label='Parking Details'
                name='packingDetails'
                value={payload?.packingDetails}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('packingDetails', e.target.value);
                }}
            />
            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
            <CustomTextField
                error={errors?.billOfLadingNumber.length > 0}
                helperText={
                    errors?.billOfLadingNumber?.length > 0
                        ? errors?.billOfLadingNumber
                        : undefined
                }
                value={payload?.billOfLadingNumber}
                required
                id='quotation-billOfLadingNumber'
                label='Bill of Lading Number'
                name='billOfLadingNumber'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('billOfLadingNumber', e.target.value);
                }}
            />

            {quoteFields.map((item, index) => (
                <Certificateoforiginfield
                    key={item.id}
                    index={index}
                    id={item.id ?? ''}
                    updateQuoteField={updateQuoteField}
                    removeQuoteField={removeQuoteField}
                    item={item}
                />
            ))}

            <SuitUIButton
                text='Add field'
                onClick={addQuoteField}
                invert
                fullWidth
                style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
            />
        </div>
    );
};

export default StepOne;
